<template>
  <b-modal
    ref="modalUpsertTemplate"
    :visible="editPathwayCohortActive"
    @hidden="closeModal"
    size="lg"
    :busy="busy"
    :title="`Edit Pathway Cohort`"
    ok-title="Save Changes"
    centered
    body-class="pt-0"
    @ok="saveChanges"
  >
    <b-row>
      <b-col cols="12" md="12" lg="12">
        <b-form-group label="Cohort Alias" label-for="pathway-cohort-nickname">
          <b-form-input required autofocus id="pathway-cohort-nickname" placeholder="" v-model="pathwayCohortEditData.nickname" />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="6">
        <b-form-group label="Visibility" label-for="pathway-cohort-visibility">
          <v-select
            v-model="pathwayCohortEditData.visibility"
            :reduce="(val) => val.value"
            :options="visibilityOptions"
            :clearable="false"
            required
            transition="smooth"
            input-id="pathway-cohort-visibility"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" lg="6">
        <b-form-group label="MyIP Integration/Automation" label-for="pathway-cohort-myip-integration">
          <b-form-checkbox
            id="pathway-cohort-myip-integration"
            :checked="pathwayCohortEditData.metadata && pathwayCohortEditData.metadata.myIp.enabled"
            @change="toggleMyIPEnabled"
            switch
            class="custom-control-primary"
            style="margin-top: 0.8rem"
          >
            {{ pathwayCohortEditData.metadata && pathwayCohortEditData.metadata.myIp.enabled ? 'Enabled' : 'Disabled' }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <!-- <b-col cols="12" md="4" lg="4">
        <b-form-group label="Status" label-for="pathway-cohort-status">
          <v-select
            v-model="pathwayCohortEditData.status"
            :options="statusOptions"
            :reduce="(val) => val.value"
            :clearable="false"
            required
            transition="smooth"
            input-id="pathway-cohort-status"
          />
        </b-form-group>
      </b-col> -->
    </b-row>
  </b-modal>
</template>

<script>
import {
  BCol,
  BFormGroup,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BFormCheckbox,
  BModal,
  BRow,
  VBModal,
} from 'bootstrap-vue';

import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import store from '@/store';
import { ref } from '@vue/composition-api/dist/vue-composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import usePathwayCohorts from '../usePathwayCohorts';
import vSelect from 'vue-select';

export default {
  name: 'PathwayCohortEditModal',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BFormCheckbox,
    BModal,
    quillEditor,
    vSelect,
  },
  directives: { 'b-modal': VBModal },
  props: {
    editPathwayCohortActive: {
      type: Boolean,
      required: true,
      default: false,
    },
    pathwayCohortData: {
      type: Object,
      default: undefined,
    },
  },
  watch: {
    '$props.editPathwayCohortActive'(val) {
      this.initModal();
    },
    '$props.pathwayCohortData'(val) {
      this.initModal();
    },
  },
  mounted() {
    this.initModal();
  },
  methods: {
    initModal() {
      if (this.$props.pathwayCohortData) {
        const { nickname, visibility, metadata, id } = this.$props.pathwayCohortData;
        this.pathwayCohortEditData = { nickname, visibility, metadata, id };
      }
    },
    closeModal() {
      this.busy = false;
      this.$emit('update:edit-pathway-cohort-active', false);
    },
    toggleMyIPEnabled() {
      if (!this.pathwayCohortEditData.metadata.myIp) {
        this.pathwayCohortEditData.metadata.myIp = { enabled: true };
      } else {
        this.pathwayCohortEditData.metadata.myIp.enabled = !this.pathwayCohortEditData.metadata.myIp.enabled;
      }
    },
    saveChanges(event) {
      this.busy = true;

      event.preventDefault();

      const pl = { ...this.pathwayCohortEditData };

      store
        .dispatch('rosterStoreModule/updatePathwayCohort', { cohortId: pl.id, pathwayCohortData: pl })
        .then((response) => {
          // this.$emit('update:pathway-data', response.data);

          this.busy = false;
          this.$emit('refetch-data');
          this.closeModal();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pathway Cohort Edited!',
              icon: 'EditIcon',
              variant: 'success',
            },
          });
        })
        .catch((error) => {
          this.busy = false;
          this.$emit('refetch-data');
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Failed to edit pathway cohort',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error.response ? error.response.data.message : error.message,
            },
          });
        });
    },
  },
  setup(props) {
    const pathwayCohortEditData = ref({});
    const busy = ref(false);

    const { statusOptions, visibilityOptions } = usePathwayCohorts();

    return { statusOptions, visibilityOptions, pathwayCohortEditData, busy };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
